import { useParams } from "react-router-dom";
import { Flex, FullscreenTakeover, QueryLoader } from "@jsq/ds/core";
import { useQueryParam } from "~/common/hooks/useQueryParams";
import { useGetProfileDetailsQuery } from "~/graphql/supergraphHooks";
import { DocumentsViewPanel } from "../../CaseDetailsDrawer/Documents/DocumentManagement/DocumentManagementDisplay/DocumentsViewPanel";
import EditEntityForm from "../../CaseDetailsDrawer/Profiles/common/EditAction/EditEntityForm";
import EditIndividualForm from "../../CaseDetailsDrawer/Profiles/common/EditAction/EditIndividualForm";
import { useCurrentCaseContext } from "../../context/CurrentCaseContext";
import JointProfileForm from "../../profile/JointProfileForm";
import {
  previewBody,
  previewPanel,
  rightPanel,
  rightPanelWrapper,
} from "../ProfileCreationPreview/styles_vanilla.css";

export const ProfileEditPreview = ({
  onComplete,
  onCancel,
  allowHierarchy = true,
}: {
  onComplete: (profileId: number) => void;
  onCancel?: () => void;
  allowHierarchy?: boolean;
}) => {
  const { caseId, programId } = useCurrentCaseContext();
  const { profileType } = useParams<{ profileType: "individual" | "joint" | "entity" }>();
  const [docId] = useQueryParam("documentId");
  const [profId] = useQueryParam("profileId");
  const documentId = Number(docId);
  const profileId = Number(profId);
  const saveButtonLabel = allowHierarchy ? "Next" : "Save and exit";

  const profileDetailsResults = useGetProfileDetailsQuery({
    variables: {
      profileId: profileId,
      programId: programId,
    },
    skip: !profileId,
    fetchPolicy: "no-cache",
  });

  return (
    <QueryLoader result={profileDetailsResults}>
      <FullscreenTakeover.Body className={previewBody}>
        <Flex className={previewPanel}>
          <DocumentsViewPanel documentId={documentId} />
        </Flex>
        <Flex className={rightPanelWrapper}>
          <Flex className={rightPanel}>
            {profileType === "joint" && (
              <JointProfileForm
                caseId={caseId}
                parentProfileId={
                  profileDetailsResults.data?.complianceProfile?.parentRelationships?.[0]
                    ?.parentProfileId
                }
                complianceProfile={profileDetailsResults.data?.complianceProfile ?? undefined}
                onCompleted={() => onComplete(profileId)}
              />
            )}
            {profileType === "individual" && (
              <EditIndividualForm
                caseId={caseId}
                complianceProfile={profileDetailsResults.data?.complianceProfile ?? undefined}
                programId={programId}
                saveButtonLabel={saveButtonLabel}
                onCancel={onCancel}
                onCompleted={() => onComplete(profileId)}
              />
            )}
            {profileType === "entity" && (
              <EditEntityForm
                caseId={caseId}
                complianceProfile={profileDetailsResults.data?.complianceProfile ?? undefined}
                programId={programId}
                saveButtonLabel={saveButtonLabel}
                onCancel={onCancel}
                onCompleted={() => onComplete(profileId)}
              />
            )}
          </Flex>
        </Flex>
      </FullscreenTakeover.Body>
    </QueryLoader>
  );
};
